const Act2022 = [
  {
    path: "/keysight220104/index",
    name: "keysight220104",
    component: (resolve) =>
      require(["@/act2022/keysight220104/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  {
    path: "/keysight220104/download",
    name: "keysight220104Download",
    component: (resolve) =>
      require(["@/act2022/keysight220104/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
  {
    path: "/keysight220117/index",
    name: "keysight220117",
    component: (resolve) =>
      require(["@/act2022/keysight220117/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  {
    path: "/keysight220117/download",
    name: "keysight220117Download",
    component: (resolve) =>
      require(["@/act2022/keysight220117/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
  {
    path: "/keysight220302/index",
    name: "keysight220302",
    component: (resolve) =>
      require(["@/act2022/keysight220302/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  {
    path: "/keysight220302/download",
    name: "keysight220302Download",
    component: (resolve) =>
      require(["@/act2022/keysight220302/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
  {
    path: "/exhibition220406/index",
    name: "exhibition220406Index",
    component: (resolve) =>
      require(["@/act2022/exhibition220406/index"], resolve),
    meta: {
      title: "高新电源电子技术培训会",
    },
  },
  {
    path: "/exhibition220408/index",
    name: "exhibition220408Index",
    component: (resolve) =>
      require(["@/act2022/exhibition220408/index"], resolve),
    meta: {
      title: "企业展台",
    },
  },
  {
    path: "/exhibition220408/video",
    name: "exhibition220408Video",
    component: (resolve) =>
      require(["@/act2022/exhibition220408/video"], resolve),
    meta: {
      title: "宣传视频",
    },
  },
  {
    path: "/exhibition220408/product",
    name: "exhibition220408Product",
    component: (resolve) =>
      require(["@/act2022/exhibition220408/product"], resolve),
    meta: {
      title: "推荐产品",
    },
  },
  {
    path: "/keysight220411/index",
    name: "keysight220411",
    component: (resolve) =>
      require(["@/act2022/keysight220411/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  {
    path: "/keysight220411/download",
    name: "keysight220411Download",
    component: (resolve) =>
      require(["@/act2022/keysight220411/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
  {
    path: "/keysight220520/index",
    name: "keysight220520",
    component: (resolve) =>
      require(["@/act2022/keysight220520/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  {
    path: "/keysight220520/download",
    name: "keysight220520Download",
    component: (resolve) =>
      require(["@/act2022/keysight220520/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
  {
    path: "/adi220524/index/:page_identify?",
    name: "adi220524",
    component: (resolve) => require(["@/act2022/adi220524/index"], resolve),
    meta: {
      title: "adi活动",
    },
  },
  {
    path: "/keysight220705/index",
    name: "keysight220705",
    component: (resolve) =>
      require(["@/act2022/keysight220705/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  {
    path: "/keysight220705/download",
    name: "keysight220705Download",
    component: (resolve) =>
      require(["@/act2022/keysight220705/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
  {
    path: "/keysight220718/index",
    name: "keysight220718",
    component: (resolve) =>
      require(["@/act2022/keysight220718/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  {
    path: "/keysight220718/download",
    name: "keysight220718Download",
    component: (resolve) =>
      require(["@/act2022/keysight220718/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
  {
    path: "/keysight220920/index",
    name: "keysight220920",
    component: (resolve) =>
      require(["@/act2022/keysight220920/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  {
    path: "/keysight220920/download",
    name: "keysight220920Download",
    component: (resolve) =>
      require(["@/act2022/keysight220920/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
  {
    path: "/keysight221010/index",
    name: "keysight221010",
    component: (resolve) =>
      require(["@/act2022/keysight221010/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  {
    path: "/keysight221010/download",
    name: "keysight221010Download",
    component: (resolve) =>
      require(["@/act2022/keysight221010/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
  {
    path: "/adi220804/index/:page_identify?",
    name: "adi220804",
    component: (resolve) => require(["@/act2022/adi220804/index"], resolve),
    meta: {
      title: "高速电路设计指南",
    },
  },
  {
    path: "/maoze220905/index",
    name: "maoze220905",
    component: (resolve) => require(["@/act2022/maoze22090501/index"], resolve),
    meta: {
      title: "贸泽电子",
    },
  },
  {
    path: "/maoze220906/index",
    name: "maoze220906",
    component: (resolve) =>
      require(["@/act2022/maoze22090501/index2"], resolve),
    meta: {
      title: "贸泽电子问卷调查",
    },
  },
  {
    path: "/tek2022091301/index",
    name: "tek2022091301",
    component: (resolve) => require(["@/act2022/tek2022091301/index"], resolve),
    meta: {
      title: "泰克问卷",
    },
  },
  {
    path: "/tek2022091301/index2",
    name: "tek2022091302",
    component: (resolve) =>
      require(["@/act2022/tek2022091301/index2"], resolve),
    meta: {
      title: "泰克问卷",
    },
  },
  {
    path: "/tek2022091301/index3",
    name: "tek2022091303",
    component: (resolve) =>
      require(["@/act2022/tek2022091301/index3"], resolve),
    meta: {
      title: "泰克问卷",
    },
  },
  {
    path: "/tek2022091301/index4",
    name: "tek2022091304",
    component: (resolve) =>
      require(["@/act2022/tek2022091301/index4"], resolve),
    meta: {
      title: "泰克问卷",
    },
  },
  {
    path: "/tek2022091301/index5",
    name: "tek2022091305",
    component: (resolve) =>
      require(["@/act2022/tek2022091301/index5"], resolve),
    meta: {
      title: "泰克问卷",
    },
  },
  {
    path: "/tek2022091301/index6",
    name: "tek2022091306",
    component: (resolve) =>
      require(["@/act2022/tek2022091301/index6"], resolve),
    meta: {
      title: "泰克问卷",
    },
  },
  // 英特尔直播1104问卷
  {
    path: "/Intel20221026/index",
    name: "Intel20221026",
    component: (resolve) => require(["@/act2022/Intel20221026/index"], resolve),
    meta: {
      title: "英特尔直播问卷",
    },
  },
  // 英特尔直播1111问卷
  {
    path: "/Intel20221027/index",
    name: "Intel20221027",
    component: (resolve) => require(["@/act2022/Intel20221027/index"], resolve),
    meta: {
      title: "英特尔直播问卷",
    },
  },
  //英特尔成功抽奖页面
  {
    path: "/Intel2022success/index",
    name: "Intel2022success",
    component: (resolve) =>
      require(["@/act2022/Intel2022success/index"], resolve),
    meta: {
      title: "英特尔抽奖页面",
    },
  },
  // adi白皮书
  {
    path: "/adi221109/index/:page_identify?",
    name: "adi221109",
    component: (resolve) => require(["@/act2022/adi221109/index.vue"], resolve),
    meta: {
      title: "活动",
    },
  },
  // 英特尔报名活动
//   {
//     path: "/Intel20221214/index",
//     name: "Intel20221214",
//     component: (resolve) =>
//       require(["@/act2022/Intel20221214/index.vue"], resolve),
//     meta: {
//       title: "英特尔邀请函",
//     },
//   },
  // 英特尔无客户代表和客户邮箱
//   {
//     path: "/Intel20221214nocustom/index",
//     name: "Intel20221214nocustom",
//     component: (resolve) =>
//       require(["@/act2022/Intel20221214nocustom/index.vue"], resolve),
//     meta: {
//       title: "英特尔邀请函",
//     },
//   },
  // 英特尔有客户代表和客户邮箱
//   {
//     path: "/Intel20221214custom/index",
//     name: "Intel20221214custom",
//     component: (resolve) =>
//       require(["@/act2022/Intel20221214custom/index.vue"], resolve),
//     meta: {
//       title: "英特尔邀请函",
//     },
//   },
  // 英特尔导出2214
//   {
//     path: "/Intel20221214JoinExcel/index",
//     name: "Intel20221214custom",
//     component: (resolve) =>
//       require(["@/act2022/Intel20221214JoinExcel/index.vue"], resolve),
//     meta: {
//       title: "英特尔导出",
//     },
//   },
  // 英特热导出2215
//   {
//     path: "/Intel20221215JoinExcel/index",
//     name: "Intel20221214custom",
//     component: (resolve) =>
//       require(["@/act2022/Intel20221215JoinExcel/index.vue"], resolve),
//     meta: {
//       title: "英特尔导出",
//     },
//   },
  // 是德台式电源
  {
    path: "/keysight221223/index",
    name: "keysight221223",
    component: (resolve) =>
      require(["@/act2022/keysight221223/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  // 是德台式电源资料下载
  {
    path: "/keysight221223/download",
    name: "keysight221223Download",
    component: (resolve) =>
      require(["@/act2022/keysight221223/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
];

export default Act2022;
